module.exports = __webpack_public_path__ + "assets/img/62cbcabe92bff310087d6862fc1aade3.png";